
import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

import { TitleCasePipe } from "@angular/common";

import { HelperService } from "../../../../../../services/helperService";
import { ChooseServiceComponent } from "../choose-service.component";

import moment from "moment";
import { LookAndFeelWebView } from "src/models/LookAndFeelWebView";
import { PublicSiteConfig } from "src/services/publicSiteConfig.service";
import { PublicSiteConfigBaseComponent } from "src/app/base/publicSiteConfigBase.component";


@Component({
    selector: 'app-calendar-web-hour',
    templateUrl: './calendar-web-hour.component.html',
    styleUrls: ['./calendar-web-hour.component.sass'],
    providers: [
        TitleCasePipe
    ],
    standalone: false
})
export class CalendarWebHourComponent extends PublicSiteConfigBaseComponent {
  // alternatively also the host parameter in the @Component()` decorator can be used
  @HostBinding('class.isDisabled') isDisabled: boolean = false;
  @Output() timeChanged: EventEmitter<string> = new EventEmitter();
  @Output() dateChanged: EventEmitter<string> = new EventEmitter();
  @Input() Indexbrand: String = "";
  @Input() timeListButtons:any[] = []
  @Input() dateFilter!: (date: Date | null) => boolean
  @Input() LanguageForCountry:any ={}
  public calendarTime!: Date | null

  otrasHoras: any
  brand = {} as LookAndFeelWebView;
  webview = {} as LookAndFeelWebView;
  disable:boolean = false
  appointmentSchedule: any;
  appointmentSchedule2: any;
  hourButton:string =""
  fechas: any
  fehcasTemp: any[] = []
  timehours: string[] = [];
  
  constructor(public titleCasePipe: TitleCasePipe,
    public helperService: HelperService,
    public ChooseServiceComponent: ChooseServiceComponent,
    public override publicSiteConfig:PublicSiteConfig) 
  {
    super(publicSiteConfig);
  }
  
  protected override afterConfigLoaded(): void {
    this.data_hours(this.indexbrand);
    this.brand = this.CurrentBrand;
    this.webview = this.CurrentBrand;
  }

  data_hours(index:number)
  {
   if (index === 2){
    this.timehours=[];
   }
   if (index === 3 || index === 4){
    this.timehours=[];
   }
  }
  

  SelectDateDinamic() {    
    let dateonDDMMYY = moment(this.calendarTime).format("DD/MM/YYYY")

    this.dateChanged.emit(dateonDDMMYY)
  }

  timeValue(e,index) {

    this.timeListButtons.forEach((name,i) => {
      name.class ="btn-hour"
        if(i === index){ name.class ="btn-hour-hover"}
      
    });
    
    this.hourButton = e.hours
    this.timeChanged.emit(this.hourButton);
  }

  public isMeeting(date: Date) {

    return (date.getDate().toString()) ? "meeting" : "";

  }

  public isYearMeeting(date: Date) {
    return date.getMonth() % 3 ? "meeting" : "";
  }
}
